var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var WorkflowController = {
    /*****************************************************************************************************
        * Is using route "api/workflow/group/{groupId}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {ExtendedDataCollection<WorkflowDownloadDto, string>}
    ******************************************************************************************************/
    GetGroupWorkflows: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/group/{groupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ExtendedDataCollection<UserShortInfoDownloadDto, WorkflowDownloadDto>}
    ******************************************************************************************************/
    GetWorkflow: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/validate/test" and http method "POST" to call the back-end.
    
        * @param {WorkflowUploadDto} dto
        * @returns {string}
    ******************************************************************************************************/
    TestWorkflow: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/validate/test", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dto
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {WorkflowUploadDto} dto
        * @returns {ExtendedDataCollection<UserShortInfoDownloadDto, WorkflowDownloadDto>}
    ******************************************************************************************************/
    UpdateWorkflow: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dto
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow" and http method "POST" to call the back-end.
    
        * @param {WorkflowUploadDto} dto
        * @returns {ExtendedDataCollection<UserShortInfoDownloadDto, WorkflowDownloadDto>}
    ******************************************************************************************************/
    CreateWorkflow: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dto
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}" and http method "GET" to call the back-end.
    
        * @param {string} itemId
        * @returns {WorkflowDownloadDto}
    ******************************************************************************************************/
    GetWorkflowForItem: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}/state" and http method "GET" to call the back-end.
    
        * @param {string} itemId
        * @returns {WorkflowStateDownloadDto}
    ******************************************************************************************************/
    GetWorkflowStateForItem: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}/state", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}/state/users" and http method "GET" to call the back-end.
    
        * @param {string} itemId
        * @returns {WorkflowStateUsersDownloadDto}
    ******************************************************************************************************/
    GetWorkflowStateUsersForItem: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}/state/users", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}/state/approvals" and http method "GET" to call the back-end.
    
        * @param {string} itemId
        * @returns {WorkflowStateApprovalDownloadDto[]}
    ******************************************************************************************************/
    GetWorkflowStateApprovalsForItem: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}/state/approvals", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/workflow/advance/{itemWorkflowId}/{stateId}/{date}" and http method "POST" to call the back-end.
    
        * @param {string} itemWorkflowId
        * @param {string} stateId
        * @param {number} date
        * @returns {WorkflowStateDownloadDto}
    ******************************************************************************************************/
    AdvanceWorkflowCallback: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/advance/{itemWorkflowId}/{stateId}/{date}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}/state/advance" and http method "POST" to call the back-end.
    
        * @param {string} itemId
        * @returns {WorkflowStateDownloadDto}
    ******************************************************************************************************/
    AdvanceWorkflow: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}/state/advance", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{itemId}/state/{approve}" and http method "POST" to call the back-end.
    
        * @param {string} itemId
        * @param {boolean} approve
        * @param {string} reason
        * @returns {WorkflowStateDownloadDto}
    ******************************************************************************************************/
    ApproveWorkflowStep: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("reason", JSON.stringify(data.reason));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{itemId}/state/{approve}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{id}/comments" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserCommentsDownloadDto}
    ******************************************************************************************************/
    GetWorkflowItemComments: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{id}/comments", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/workflow/item/{id}/comments" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {UserCommentUploadDto} comment
        * @returns {UserCommentsDownloadDto}
    ******************************************************************************************************/
    AddWorkflowItemComment: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/workflow/item/{id}/comments", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.comment
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=WorkflowController.js.map